"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameCollectStation = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
class GameCollectStation {
    constructor() {
        this._structureVersion = undefined;
        this.identifier = undefined;
        this.contextId = undefined;
        this.name = undefined;
        this.huntingDistrictId = undefined;
        this.huntingDistrictName = undefined;
        this.comment = undefined;
        this.creationDate = undefined;
        this.updateTimestamp = undefined;
    }
    setFromAny(element) {
        const { _structureVersion, identifier, contextId, name, comment, huntingDistrictId, huntingDistrictName, creationDate, updateTimestamp } = element;
        this._structureVersion = _structureVersion ? _structureVersion : this._structureVersion;
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.name = name ? name : this.name;
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId;
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName;
        this.comment = comment ? comment : this.comment;
        this.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
    }
    searchFilter(filter) {
        const str = `${this.name}`.toLowerCase();
        return str.includes(filter);
    }
    replacerFn(key) {
        return true;
    }
}
exports.GameCollectStation = GameCollectStation;
